module.exports = __webpack_public_path__ + "static/media/libro_reclamaciones.4d7af8a7.png";